export default "__VITE_ASSET__Cvzq0zTJ__"